/**
 * Kommend Glyph logo — the "K Wings" mark extracted from logo-concepts-v5.html (variant 04 Glyph).
 * Renders as inline SVG so it works in both light/dark themes without external file dependency.
 */
export function KommendLogo({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="kommend-bg" x1="0" y1="0" x2="200" y2="200" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#BE185D" />
          <stop offset="48%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#2563EB" />
        </linearGradient>
      </defs>
      <rect width="200" height="200" rx="44" fill="url(#kommend-bg)" />
      <g transform="rotate(-15, 100, 100)">
        <rect x="34" y="10" width="38" height="180" rx="19" fill="white" />
        <path d="M62,66 Q110,22 168,4 L174,28 Q120,56 86,104 Z" fill="white" />
        <path d="M62,134 Q110,178 168,196 L174,172 Q120,144 86,96 Z" fill="white" />
      </g>
    </svg>
  );
}
